export default __webpack_public_path__ + "static/media/bag.a779a96c.svg";